/* ============================================================
   LIVLAB SCANNER — livlab-scanner.js
   À placer dans : assets/livlab-scanner.js
   ============================================================ */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.getElementById('llscanner-root');
    if (!root) return;

    // ── État global ──
    var currentStep         = 1;
    var uploadedFile        = null;
    var analysisComplete    = false;
    var isNewsletterChecked = true;

    // ── Éléments DOM ──
    var fileInput       = root.querySelector('#llscanner-file-input');
    var uploadZone      = root.querySelector('#llscanner-upload-zone');
    var filePreview     = root.querySelector('#llscanner-file-preview');
    var fileNameEl      = root.querySelector('#llscanner-file-name');
    var fileRemoveBtn   = root.querySelector('#llscanner-file-remove');
    var step1NextBtn    = root.querySelector('#llscanner-step1-next');
    var submitEmailBtn  = root.querySelector('#llscanner-submit-email');
    var firstNameInput  = root.querySelector('#llscanner-first-name');
    var emailInput      = root.querySelector('#llscanner-email-input');
    var productUrlInput = root.querySelector('#llscanner-product-url');
    var consentGroup    = root.querySelector('#llscanner-consent-group');
    var consentError    = root.querySelector('#llscanner-consent-error');
    var checkboxVisual  = root.querySelector('#llscanner-checkbox-visual');
    var successMsg      = root.querySelector('#llscanner-success-msg');
    var errorMsg        = root.querySelector('#llscanner-error-msg');

    var ICON_SVG = '<svg width="13" height="13" viewBox="0 0 14 14" fill="none"><polyline points="2,7 6,11 12,3" stroke="#002B14" stroke-width="2.5"/></svg>';

    // ── Activation du bouton Continuer selon l'URL (obligatoire) ──
    function checkStep1Valid() {
      var url = productUrlInput.value.trim();
      step1NextBtn.disabled = url.length === 0;
    }

    productUrlInput.addEventListener('input', checkStep1Valid);
    productUrlInput.addEventListener('paste', function () {
      // paste déclenche input avec léger délai
      setTimeout(checkStep1Valid, 0);
    });

    // ── Upload zone (optionnel) ──
    uploadZone.addEventListener('click', function () {
      fileInput.click();
    });

    fileInput.addEventListener('change', function (e) {
      if (e.target.files.length > 0) {
        uploadedFile = e.target.files[0];
        fileNameEl.textContent = uploadedFile.name;
        filePreview.classList.add('show');
        uploadZone.classList.add('has-file');
      }
    });

    fileRemoveBtn.addEventListener('click', function () {
      uploadedFile = null;
      fileInput.value = '';
      filePreview.classList.remove('show');
      uploadZone.classList.remove('has-file');
    });

    uploadZone.addEventListener('dragover', function (e) {
      e.preventDefault();
      uploadZone.style.borderColor = '#76DB5D';
    });

    uploadZone.addEventListener('dragleave', function () {
      uploadZone.style.borderColor = '';
    });

    uploadZone.addEventListener('drop', function (e) {
      e.preventDefault();
      uploadZone.style.borderColor = '';
      if (e.dataTransfer.files.length > 0) {
        uploadedFile = e.dataTransfer.files[0];
        fileNameEl.textContent = uploadedFile.name;
        filePreview.classList.add('show');
        uploadZone.classList.add('has-file');
      }
    });

    // ── Checkbox consentement (pure JS, sans input natif) ──
    checkboxVisual.addEventListener('click', function () {
      isNewsletterChecked = !isNewsletterChecked;
      if (isNewsletterChecked) {
        checkboxVisual.classList.remove('llscanner-unchecked');
        checkboxVisual.innerHTML = ICON_SVG;
        consentGroup.classList.remove('llscanner-consent-error');
        consentError.classList.remove('show');
      } else {
        checkboxVisual.classList.add('llscanner-unchecked');
        checkboxVisual.innerHTML = '';
      }
    });

    // ── Step 1 -> Step 2 ──
    step1NextBtn.addEventListener('click', function () {
      goToStep(2);
      setTimeout(function () {
        simulateAnalysis();
      }, 80);
    });

    // ── Simulation analyse + barre de progression ──
    function simulateAnalysis() {
      var analysisLoading = root.querySelector('#llscanner-analysis-loading');
      var emailForm       = root.querySelector('#llscanner-email-form');
      var fill            = root.querySelector('#llscanner-progress-fill');
      var txt             = root.querySelector('#llscanner-loading-text');

      analysisLoading.style.display = 'block';
      emailForm.style.display       = 'none';

      fill.style.transition = 'none';
      fill.style.width = '0%';
      txt.textContent = 'Analyse en cours...';

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          fill.style.transition = 'width 0.4s ease';
          var progress = 0;
          var interval = setInterval(function () {
            progress += Math.random() * 12 + 3;
            if (progress >= 100) {
              progress = 100;
              clearInterval(interval);
              setTimeout(function () {
                analysisLoading.style.display = 'none';
                emailForm.style.display       = 'block';
                analysisComplete = true;
              }, 500);
            }
            fill.style.width = progress + '%';
            if (progress < 30) {
              txt.textContent = 'Extraction des ingrédients...';
            } else if (progress < 60) {
              txt.textContent = 'Analyse des dosages...';
            } else if (progress < 90) {
              txt.textContent = 'Calcul des scores et de la fiabilité...';
            } else {
              txt.textContent = 'Finalisation...';
            }
          }, 300);
        });
      });
    }

    // ── Soumission email ──
    submitEmailBtn.addEventListener('click', async function () {

      if (!isNewsletterChecked) {
        consentGroup.classList.add('llscanner-consent-error');
        consentError.classList.add('show');
        consentGroup.style.animation = 'none';
        void consentGroup.offsetWidth;
        consentGroup.style.animation = 'llscanner-shake .35s ease';
        return;
      }

      var firstName = firstNameInput ? firstNameInput.value.trim() : '';
      if (!firstName) {
        showError('Veuillez entrer votre prénom');
        return;
      }

      var email = emailInput.value.trim();
      if (!email || !email.includes('@')) {
        showError('Veuillez entrer un email valide');
        return;
      }

      submitEmailBtn.disabled    = true;
      submitEmailBtn.textContent = 'Envoi en cours...';

      var formData = new FormData();
      if (uploadedFile) formData.append('image', uploadedFile);
      formData.append('first_name',       firstName);
      formData.append('email',            email);
      formData.append('product_url',      productUrlInput ? productUrlInput.value : '');
      formData.append('newsletter_optin', isNewsletterChecked);

      try {
        var webhookUrl = root.dataset.webhookUrl || '';
        if (webhookUrl) {
          var response = await fetch(webhookUrl, { method: 'POST', body: formData });
          if (!response.ok) throw new Error('Network error');
        } else {
          await new Promise(function (resolve) { setTimeout(resolve, 1500); });
        }
        goToStep(3);
        showSuccess();
      } catch (error) {
        showError('Une erreur est survenue. Veuillez réessayer.');
        submitEmailBtn.disabled    = false;
        submitEmailBtn.textContent = 'Recevoir mon analyse';
      }
    });

    // ── Navigation ──
    function goToStep(step) {
      currentStep = step;
      updateStepper();
      root.querySelectorAll('.llscanner-section').forEach(function (s) {
        s.classList.remove('active');
      });
      root.querySelector('#llscanner-step' + step + '-content').classList.add('active');
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function updateStepper() {
      for (var i = 1; i <= 3; i++) {
        var stepEl   = root.querySelector('#llscanner-stepper-step' + i);
        var numberEl = stepEl.querySelector('.llscanner-step-num');
        var labelEl  = stepEl.querySelector('.llscanner-step-label');
        if (i < currentStep) {
          numberEl.className = 'llscanner-step-num completed';
          labelEl.className  = 'llscanner-step-label completed';
        } else if (i === currentStep) {
          numberEl.className = 'llscanner-step-num active';
          labelEl.className  = 'llscanner-step-label active';
        } else {
          numberEl.className = 'llscanner-step-num inactive';
          labelEl.className  = 'llscanner-step-label inactive';
        }
      }
      root.querySelector('#llscanner-stepper-progress').textContent = 'Étape ' + currentStep + '/3';
    }

    // ── Messages ──
    function showSuccess() {
      successMsg.classList.add('show');
      errorMsg.classList.remove('show');
    }

    function showError(msg) {
      errorMsg.textContent = msg;
      errorMsg.classList.add('show');
      successMsg.classList.remove('show');
    }

  });
})();